import { styled } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';
import { animated } from 'react-spring';

export const TabWrapper = styled.div`
  min-height: 44px;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 6px;
  position: relative;
  z-index: 1;
  width: 100%;
`;

export const Indicator = styled(animated.span)`
  position: absolute;
  bottom: 0;
  height: calc(100% - 12px);
  transition: ${animationTransition('background-color')};
  left: 0;
  width: 0;
  background-color: white;
  box-shadow: 0px 1px 3px -1px rgba(51, 51, 51, 0.1);
  border-radius: 200px;
  z-index: 0;
  top: 50%;
`;

export const TabsRoot = styled.div<{ width?: string; isMobile?: boolean }>`
  width: ${({ width, isMobile }) => (width && !isMobile ? width : isMobile ? '100%' : 'initial')};
  position: relative;
  background: ${props => props.theme.colors.mono2};
  border-radius: 200px;
`;
